import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/invitations/accept')({
  validateSearch: (raw: Record<string, unknown>) => ({
    token: typeof raw.token === 'string' ? raw.token : '',
  }),
})
